import { render, staticRenderFns } from "./NavbarTopWithBackBtn.vue?vue&type=template&id=e80c780c&scoped=true"
import script from "./NavbarTopWithBackBtn.vue?vue&type=script&lang=js"
export * from "./NavbarTopWithBackBtn.vue?vue&type=script&lang=js"
import style0 from "./NavbarTopWithBackBtn.vue?vue&type=style&index=0&id=e80c780c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80c780c",
  null
  
)

export default component.exports